import React, { useState, useEffect, useContext } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Home_context } from '../../context/home_context';
// let dummy_data=[
//     {
//         'RM Code':'0384',
//         'Standard price':'10.0000 USD',
//         'Properties':'cell stimulating agent anti-aging anti-wrinkles skin elasticity skin softener emollient',
//         'Product type':'Plant extract Active',
//         'Internal Status':"Authorized",
//         'Launch Date':"Jan 2000"
    
//     }
// ]
export default function Header_table_one(){
    const { report_data_state } = useContext(Home_context);

    return (
      <div className="card">
        <DataTable
          value={[{...report_data_state?.report_data}]}
          showGridlines
          className="report_id_tables page_table_font_size"
        >
          {/* <Column field="rm_code" header="RM Code"></Column> */}
          {/* <Column field="price" header="Standard price"></Column> */}
          <Column field="properties" header="Properties"></Column>
          <Column field="product_type" header="Product type"></Column>
          {/* <Column field="internal_status" header="Internal Status"></Column> */}
          <Column field="Launch Date" header="Launch Date"></Column>
        </DataTable>
      </div>
    );
}